module.exports = __webpack_public_path__ + "static/media/logonav.d515cc78.png";